// extracted by mini-css-extract-plugin
module.exports = {"actions":"button_actions__3JzKI","relative":"button_relative__2m9-1","btn":"button_btn__3ZbCF","disabled":"button_disabled__1IH3U"};